<template>
  <div class="negotiation" :class="{ 'negotiation--fill-page': !agreement }">
    <div v-if="!agreement" class="negotiation__detail-wrap" :class="{ 'negotiation__detail-wrap--busy': loadingDueDate }">
      <div class="negotiation__detail-grid">
      <div class="negotiation__detail-left">
        <div class="negotiation__header">
          <button class="negotiation__back" type="button" :disabled="loadingDueDate" @click="voltar">
            <i class="fa fa-chevron-left"></i> Voltar
          </button>
          <p class="negotiation__subtitle">Detalhes da oferta</p>
          <div class="negotiation__debt-box" v-if="debtBoticario">
            <div class="negotiation__brand">
              <img src="/img/boticario-icone-card.png" alt="" class="negotiation__brand-icon" />
              <strong class="negotiation__brand-name">Boticário</strong>
            </div>
            <div class="negotiation__debt-row">
              <span>Valor atualizado:</span>
              <strong>{{ formatFloatToReal(debtBoticario.updatedValue) }}</strong>
            </div>
            <div class="negotiation__debt-row">
              <span>Data do atraso:</span>
              <strong>{{ lateDateBoticario }}</strong>
            </div>
            <hr class="negotiation__titles-divider" />
            <div class="negotiation__titles-row">
              <span class="negotiation__titles-label">Título(s):</span>
              <span class="negotiation__titles-value">
                {{ isTitlesExpanded ? debtBoticario.installments : truncated(debtBoticario.installments, 28) }}
              </span>
              <button
                v-if="debtBoticario.installments && debtBoticario.installments.length > 28"
                @click="isTitlesExpanded = !isTitlesExpanded"
                class="negotiation__btn-expand"
              >
                <i :class="isTitlesExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
              </button>
            </div>
          </div>

          <div class="negotiation__due-date">
            <p class="negotiation__due-date-label">Por favor, informe quando quer pagar</p>
            <div class="negotiation__due-select-wrap">
              <CustomSelect
                :model-value="dueDateBoticario"
                :options="dueDateOptions"
                placeholder="Selecione outro vencimento"
                :disabled="loadingDueDate"
                @change="onChangeDueDate"
              />
            </div>
          </div>
        </div>
      </div>

    <OfferSelector
      brand="boticario"
      detail-grid-layout
      :main-offers="mainOffersBoticario"
      :all-offers="offersBoticarioNegotiation"
      :selected-offer="selectedOfferBoticario"
      :due-dates="dueDatesBoticario"
      :due-date="dueDateBoticario"
      :loading="loading"
      :loading-due-date="loadingDueDate"
      @prepare-agreement="onPrepareAgreement"
      @change-due-date="onChangeDueDate"
      @select-offer="onSelectOffer"
      @voltar-pendencias="voltar"
    >
      <template #loading>
        <ProgressLoading :loading="loading" />
      </template>
    </OfferSelector>
      </div>
      <div
        v-if="loadingDueDate"
        class="negotiation__busy-overlay"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <ProgressLoading :loading="true" />
      </div>
    </div>

    <AgreementSuccess
      v-if="agreement"
      :agreement="agreement"
      :prepare-to-set-agreement="prepareToSetAgreement"
      :selected-payment-method="selectedPaymentMethod"
      brand="boticario"
      @return-to-dashboard="onReturnToDashboardAfterAgreement"
      @copied="onCopied"
    />


    <ConfirmAgreementModal
      brand="boticario"
      :prepare-to-set-agreement="prepareToSetAgreement"
      :selected-payment-method="selectedPaymentMethod"
      :is-accept-card-enabled="acceptCardEnabled"
      :loading="loadingSetAgreement"
      @select-payment="onSelectPayment"
      @confirm="onConfirmAgreement"
    >
      <template #loading>
        <ProgressLoading :loading="loadingSetAgreement" />
      </template>
    </ConfirmAgreementModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { formatDocument } from '@/utils/helpers';
import ProgressLoading from '@/modules/auth/components/ProgressLoading';
import OfferSelector from './OfferSelector.vue';
import AgreementSuccess from './AgreementSuccess.vue';
import ConfirmAgreementModal from './ConfirmAgreementModal.vue';
import CustomSelect from './CustomSelect.vue';

export default {
  name: 'NegotiationBoticario',
  components: { ProgressLoading, OfferSelector, AgreementSuccess, ConfirmAgreementModal, CustomSelect },
  data: () => ({ isTitlesExpanded: false }),
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('negotiation', [
      'debtBoticario', 'mainOffersBoticario', 'offersBoticarioNegotiation',
      'selectedOfferBoticario', 'dueDatesBoticario', 'dueDateBoticario',
      'lateDateBoticario', 'agreement', 'prepareToSetAgreement',
      'selectedPaymentMethod', 'loading', 'loadingDueDate', 'loadingSetAgreement',
    ]),

    displayName() {
      let name = this.user?.FullName;
      if (!name) {
        try { name = JSON.parse(localStorage.getItem('user'))?.FullName; } catch { name = null; }
      }
      const normalized = typeof name === 'string' ? name.trim() : '';
      const doc = this.user?.DocNumber ? String(this.user.DocNumber).replace(/\D/g, '') : '';
      const nameDigits = normalized.replace(/\D/g, '');
      const isJustDocument = normalized !== '' && (
        normalized === this.user?.DocNumber
        || (doc !== '' && nameDigits === doc)
      );
      if (normalized === '' || isJustDocument) return 'Usuário';
      return normalized.includes(' ') ? normalized.split(' ')[0] : normalized;
    },
    maskedCpf() {
      if (!this.user?.DocNumber) return '';
      const doc = formatDocument(this.user.DocNumber);
      return doc.split('.')[0].substring(0, 6) + '.xxx.xxx-' + doc.split('-')[1];
    },
    acceptCardEnabled() {
      return this.$store.getters['negotiation/isAcceptCardEnabled'](this.prepareToSetAgreement);
    },
    dueDateOptions() {
      return (this.dueDatesBoticario || []).map(d => ({ value: d, label: d }));
    },
  },
  methods: {
    ...mapActions('negotiation', [
      'ActionNegotiationGoToDashboard',
      'ActionNegotiationChangeDueDateBoticario',
      'ActionNegotiationPrepareAgreement',
      'ActionNegotiationSelectPaymentMethod',
      'ActionNegotiationSetAgreementBoticario',
    ]),

    voltar() { this.ActionNegotiationGoToDashboard(); },
    onChangeDueDate(value) { this.ActionNegotiationChangeDueDateBoticario(value); },
    onPrepareAgreement(offer) { this.ActionNegotiationPrepareAgreement(offer); },
    onSelectOffer(installmentNumber) {
      const offer = this.offersBoticarioNegotiation.find(o => o.installmentNumber == installmentNumber);
      if (offer) this.$store.commit('negotiation/SET_SELECTED_OFFER_BOTICARIO', offer);
    },
    onSelectPayment(method) { this.ActionNegotiationSelectPaymentMethod(method); },

    async onConfirmAgreement() {
      try {
        await this.ActionNegotiationSetAgreementBoticario();
        this.fecharModal('confirmAgreementModalBoticario');
        this.flashMessage.show({ timeout: 1000, status: 'success', title: 'Sucesso', blockClass: 'custom-block-class', message: 'Acordo fechado com sucesso' });
      } catch (err) {
        this.flashMessage.show({
          timeout: 8000,
          status: 'error',
          position: 'top right',
          title: 'Erro',
          message: err.message || 'Não foi possível confirmar na tela. Atualize a página antes de tentar de novo; o acordo pode já ter sido registrado.',
        });
      }
    },

    async onReturnToDashboardAfterAgreement() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      // Após fechar acordo, refaz getDebts para refletir o novo acordo no dashboard.
      await this.ActionNegotiationGoToDashboard({ refresh: true });
    },

    onCopied() {
      this.flashMessage.show({ timeout: 1000, status: 'success', title: 'Sucesso', blockClass: 'custom-block-class', message: 'Código copiado com sucesso' });
    },

    formatFloatToReal(value) {
      return parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    truncated(text, length) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '...' : text;
    },
    fecharModal(id) {
      const modal = document.getElementById(id);
      if (!modal) return;
      modal.classList.remove('show');
      modal.style.display = 'none';
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) backdrop.remove();
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    },
  },
};
</script>

<style scoped>
.negotiation {
  padding-top: 8px;
  padding-bottom: 32px;
}

.negotiation__header {
  margin-bottom: 24px;
}

.negotiation__back {
  background: none;
  border: none;
  color: #176e53;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}
.negotiation__back:hover { text-decoration: underline; }
.negotiation__back:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
.negotiation__back:disabled:hover {
  text-decoration: none;
}

.negotiation__detail-wrap {
  position: relative;
  width: 100%;
}

.negotiation__busy-overlay {
  position: absolute;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(1px);
}

.negotiation__hello {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  color: #333438;
  margin: 0;
}

.negotiation__cpf {
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  font-style: italic;
  color: #666;
  margin: 0;
}

.negotiation__subtitle {
  font-family: 'Inter', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #333438;
  margin: 12px 0 16px;
}

.negotiation__debt-box {
  border: none;
  border-top: 4px solid #06a472;
  border-radius: 20px;
  padding: 16px 20px;
  background-color: #fff;
  box-shadow: var(--negotiation-card-shadow, 0 2px 12px rgba(0, 0, 0, 0.08));
}

.negotiation__brand {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.negotiation__brand-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.negotiation__brand-name {
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #333438;
}

.negotiation__debt-row {
  display: flex;
  gap: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 0.82rem;
  color: #333438;
}

.negotiation__debt-row span {
  white-space: nowrap;
  color: #666;
  font-weight: 400;
}

.negotiation__titles-divider {
  margin: 4px 0;
  border-color: #e6e7e9;
}

.negotiation__titles-row {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-family: 'Inter', sans-serif;
  font-size: 0.82rem;
  color: #666;
}
.negotiation__titles-label {
  font-weight: 400;
  white-space: nowrap;
  flex-shrink: 0;
}
.negotiation__titles-value {
  font-family: 'Inter', sans-serif;
  font-size: 0.82rem;
  font-weight: 400;
  color: #333438;
  word-break: break-word;
  line-height: 1.4;
  flex: 1;
}
.negotiation__btn-expand {
  background: transparent;
  border: none;
  color: #176e53;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: auto;
}
.negotiation__btn-expand:focus { outline: none; }
.negotiation__btn-expand i { font-size: 0.85rem; }

.negotiation__due-date {
  margin-top: 16px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}
.negotiation__due-date-label {
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  color: #333438;
  margin-bottom: 8px;
}

.negotiation__due-select-wrap {
  width: 100%;
  min-width: 0;
}
.negotiation__due-date-wrapper {
  position: relative;
}
.negotiation__due-date-select {
  width: 100%;
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid #d0d0d0;
  border-radius: 12px;
  padding: 14px 40px 14px 16px;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  color: #333438;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23333438' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E") no-repeat right 16px center;
  cursor: pointer;
}
.negotiation__due-date-select:focus {
  outline: none;
  border-color: #06a472;
}

@media (min-width: 768px) {
  .negotiation__back {
    display: none;
  }

  .negotiation--fill-page {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    padding-bottom: 12px;
  }

  .negotiation--fill-page .negotiation__detail-wrap {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .negotiation__detail-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 32px;
    row-gap: 14px;
    align-items: start;
  }

  .negotiation--fill-page .negotiation__detail-grid {
    flex: 1;
    min-height: 0;
    grid-template-rows: auto auto auto auto 1fr;
  }

  .negotiation__detail-left,
  .negotiation__header,
  .negotiation__due-date {
    display: contents;
  }

  .negotiation__detail-grid .negotiation__header {
    margin-bottom: 0;
  }

  .negotiation__subtitle {
    grid-column: 1;
    grid-row: 1;
    margin: 0;
    align-self: end;
  }

  .negotiation__detail-grid ::v-deep .offer-selector__label--main {
    grid-column: 2;
    grid-row: 1;
    margin: 0;
    align-self: end;
  }

  .negotiation__debt-box {
    grid-column: 1;
    grid-row: 2;
    align-self: start;
    width: 100%;
  }

  .negotiation__detail-grid ::v-deep .offer-list {
    grid-column: 2;
    grid-row: 2;
    align-self: start;
    width: 100%;
    min-width: 0;
  }

  .negotiation__due-date-label {
    grid-column: 1;
    grid-row: 3;
    margin-bottom: 0;
    align-self: end;
  }

  .negotiation__detail-grid ::v-deep .offer-selector__label--more {
    grid-column: 2;
    grid-row: 3;
    margin-top: 0;
    margin-bottom: 0;
    align-self: end;
  }

  .negotiation__due-select-wrap {
    grid-column: 1;
    grid-row: 4;
    width: 100%;
    min-width: 0;
  }

  .negotiation__detail-grid ::v-deep .styled-select-wrapper {
    grid-column: 2;
    grid-row: 4;
    margin-bottom: 0;
    width: 100%;
    min-width: 0;
  }

  .negotiation__detail-grid ::v-deep .offer-selector__footer {
    grid-column: 1 / -1;
    grid-row: 5;
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
  }

  .negotiation--fill-page .negotiation__detail-grid ::v-deep .offer-selector__footer {
    align-self: end;
  }

  .negotiation__detail-grid ::v-deep .offer-selector__footer .btn-confirm {
    width: 100%;
  }
}
</style>
